import type NumberUnit from '@exodus/currency';
import type { SendOptions } from '@passkeys/transactions';

import type { Nft } from '@/ui/types';
import { getChainFromNft } from '@/ui/utils/nfts';

type UseCollectibleTransactionParams = {
  collectible: Nft;
  walletAccount: string;
  toAddress: string;
  fees: { fee: NumberUnit };
};

function createSendOptions({
  collectible,
  walletAccount,
  toAddress,
  fees,
}: UseCollectibleTransactionParams): SendOptions {
  return {
    assetName: getChainFromNft(collectible),
    receiver: {
      address: toAddress,
    },
    walletAccount,
    fees,
    nft: collectible,
  };
}

export default createSendOptions;
